<template>
    <div class="mt-5 md:mt-0 md:col-span-3 pr-10">
        <h1 class="text-2xl font-medium text-black mt-6 mb-1 hidden md:block">Profile</h1>
        <hr class="hidden md:block">

            <div id="errors-top">
                <div v-if="errors > 0" class="rounded-md bg-red-50 p-4">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <!-- Heroicon name: solid/x-circle -->
                            <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h2 class="text-sm font-medium text-red-800">
                                There were (number of errors) error(s) saving this resource
                            </h2>
                            <div class="mt-2 text-sm text-red-700">
                                <ul class="list-disc pl-5 space-y-1">
                                        <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div class="sm:rounded-md sm:overflow-hidden">
            <div class="sm:items-start">
                <label for="name" class="block text-lg font-medium text-black sm:mt-2 sm:pt-2">
                    Name
                </label>
                <div class="mt-1 sm:col-span-5">
                    <input v-model="user.name"
                            type="text"
                            class="max-w-lg block w-full shadow-sm primary-focus sm:max-w-xs sm:text-base border-slate-300 rounded-[12px] text-neutral-400 font-medium">
                </div>
            </div>
            <div class="sm:items-start mt-4">
                <label for="email" class="block text-lg font-medium text-black sm:mt-2 sm:pt-2">
                    Email
                </label>
                <div class="mt-1 sm:col-span-5">
                    <input v-model="user.email"
                            type="text"
                            class="max-w-lg block w-full shadow-sm primary-focus sm:max-w-xs sm:text-base border-slate-300 rounded-[12px] text-neutral-400 font-medium">
                </div>
                <!-- @if(!auth()->user()->hasVerifiedEmail())
                    @if($verficationLinkSent)
                        <h2 class="font-bold text-sm col-span-6">Link sent, check your inbox ({{$user->email}})</h2>
                    @else
                        <div class="col-span-6">
                            <h2 class="text-sm">
                                Please verify your email address to finish creating your account.
                            </h2>
                            <h2>
                                <button wire:click="sendVerificationLink" wire:loading.remove wire:target="sendVerificationLink" class="font-bold underline text-sm">Send me verification link</button>.
                                <svg wire:loading wire:target="sendVerificationLink" xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960"  class="w-6 h-6 animate-spin" fill="currentColor"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-60q68 0 130.62-25.806Q673.239-191.613 721-240L480-480v-340q-142 0-241 98.812Q140-622.375 140-480t98.812 241.188Q337.625-140 480-140Z"/></svg>
                            </h2>
                        </div>
                    @endif
                @endif -->
            </div>

            <div class="sm:items-start mt-4">
                <label for="email" class="block text-lg font-medium text-black sm:mt-2 sm:pt-2">
                    Educational Role
                </label>
                <div class="mt-1 sm:col-span-5">
                    <select name="role" id="role" v-model="user.role" class="max-w-lg block w-full shadow-sm primary-focus sm:max-w-xs sm:text-base border-slate-300 rounded-[12px] text-neutral-400 font-medium">
                        <option>Select Option</option>
                        <option value="teacher">Teacher</option>
                        <option value="school-administrator">School administrator</option>
                        <option value="school-counselor">School counselor</option>
                        <option value="university-professor">University professor</option>
                        <option value="student">Student</option>
                        <option value="other">Other</option>
                    </select>
                </div>
            </div>

            <!-- <div class="sm:items-start mt-4">
                <span class="block text-lg font-medium text-zinc-800 sm:mt-2 sm:pt-2">
                    Grade Levels Taught
                </span>
                <div class="mt-2">
                    <fieldset class="flex space-x-2">
                        <legend class="sr-only text-black">
                            <span class="">
                                Grades
                            </span>
                        </legend>
                        <div v-for="grade in allGrades">
                            <label for="{{grade}}" class="font-medium text-gray-700 pb-2">
                                <input
                                    v-model="grades[grade.id]"
                                    type="checkbox"
                                    value=""
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                >
                                {{ grade.name }}
                            </label>
                        </div>
                    </fieldset>
                </div>
            </div> -->

            <GradesPicker v-model="gradeBands" />

            <SubjectsPicker v-model="subjects" />


            <hr>

            <div class="md:flex md:justify-between">
                <div class="mt-5 mb-8">
                    <button @click="save" class="md:w-[186px] w-full h-10 px-5 py-2 bg-[#A4EBA2] rounded-[12px] justify-center items-center inline-flex">
                        <div class="text-neutral-800 text-base font-medium font-['Outfit'] tracking-tight">Save Changes</div>
                    </button>
                </div>
                <div v-if="saved">
                    <div class="mb-6 w-full rounded-lg pointer-events-auto">
                        <div class="rounded-lg shadow-xs overflow-hidden">
                            <div class="md:p-4">
                                <div class="flex md:justify-end">
                                    <div class="flex-shrink-0">
                                        <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div class="ml-3 flex-initial pt-0.5">
                                        <p class="text-sm leading-5 font-medium text-gray-900">
                                            Successfully saved!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="errors-bottom">
                <div v-if="errors > 0" class="rounded-md bg-red-50 p-4">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <!-- Heroicon name: solid/x-circle -->
                            <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h2 class="text-sm font-medium text-red-800">
                                There were {{ errors }} error(s) saving this resource
                            </h2>
                            <div class="mt-2 text-sm text-red-700">
                                <ul class="list-disc pl-5 space-y-1">
                                        <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'


import Container from '../../../Layouts/Container.vue'



import { usePage } from '@inertiajs/vue3'
import SideBar from './SideBar.vue'


import GradesPicker from './GradesPicker.vue'
import SubjectsPicker from './SubjectsPicker.vue'

export default {
    components: {
    Container,
    SideBar,
    GradesPicker,
    SubjectsPicker
},
    data() {
        return {
            errors: {},
            saved: false,
            user:{
                name: '',
                email: '',
                role: '',
            },

            subjects: [],

            gradeBands : []
        }
    },
    props: {

    },
    watch: {

    },
    setup() {
        return {  }
    },
    methods: {


        async save(){
            let data = await axios.put(route('profile.update'), {
                name: this.user.name,
                email: this.user.email,
                role: this.user.role,
                gradeBands: this.gradeBands,
                subjects : this.subjects
            }).then(resp => resp.data)

            this.saved = true;
        },

        async load(){

            let data = await axios.get(route('profile.info')).then(resp => resp.data)

            this.user.name = data.name
            this.user.email = data.email
            this.user.role = data.role
            this.subjects = data.subjects
            this.gradeBands = data.gradeBands

        }
    },
    computed: {


    },
    async mounted() {
        await this.load()
    },
}
</script>
